import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const DEFAULTS = {
  hero: {
    headline: "Umzug & Möbeltransport in Aachen, Köln, Düsseldorf & Umgebung",
    highlight: "schnell, einfach & fair",
    subheadline: "Fotos hochladen, geschätzte Preisspanne erhalten und direkt über WhatsApp bestätigen.",
    badge: "Aachen · Möbeltransport & Umzug · Antwort per WhatsApp",
    service_area: "Unser Standort ist Aachen – wir fahren regelmäßig nach Köln, Düsseldorf und in die Umgebung.",
    primary_cta: "Kleinen Transport starten",
    secondary_cta: "Umzug planen",
  },
  cards: {
    small: { title: "Kleine Transporte", description: "Für Waschmaschine, Sofa, Bett, Schrank, Kartons oder einzelne Möbelstücke.", examples: ["Waschmaschine", "Sofa, Bett", "Schrank, Kartons", "Einzelstücke"], cta: "Kleinen Transport starten" },
    full: { title: "Kompletter Umzug", description: "Für Wohnung, Haus, Büro oder mehrere Zimmer. Komplett geplant.", examples: ["Wohnung", "Haus", "Büro", "Mehrere Zimmer"], cta: "Umzug planen" },
  },
  prices: [],
  prices_note: "Alle Preise sind geschätzte Richtwerte. Der endgültige Preis wird nach Prüfung der Fotos über WhatsApp bestätigt.",
  faqs: [],
  reviews: [],
  trust: { rating_label: "4,9 / 5 Kundenzufriedenheit", count_label: "500+ Transporte", whatsapp_label: "WhatsApp-Angebot in Minuten", safety_label: "Sicherer Transport" },
  images: { hero_strip: [] },
  legal: { impressum: { owner: "", address: "", email: "", phone: "+49 176 56198464", ust_id: "", responsible: "" }, datenschutz: { intro: "", hosting: "" } },
};

const CACHE_KEY = "leukas_cms_cache_v1";

function readCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object") return parsed;
  } catch {}
  return null;
}

const CmsContext = createContext({ cms: DEFAULTS, refresh: () => {}, loaded: false });

export function CmsProvider({ children }) {
  const cached = readCache();
  const [cms, setCms] = useState(cached ? { ...DEFAULTS, ...cached } : DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  const refresh = async () => {
    try {
      const { data } = await api.get("/cms");
      if (data && typeof data === "object") {
        const next = { ...DEFAULTS, ...data };
        setCms(next);
        try { localStorage.setItem(CACHE_KEY, JSON.stringify(data)); } catch {}
      }
    } catch {
      // keep current state
    } finally {
      setLoaded(true);
    }
  };

  useEffect(() => { refresh(); }, []);

  return <CmsContext.Provider value={{ cms, refresh, loaded }}>{children}</CmsContext.Provider>;
}

export function useCms() {
  return useContext(CmsContext);
}
